import { render, staticRenderFns } from "./ForwardList.vue?vue&type=template&id=468b7a7c&scoped=true"
import script from "./ForwardList.vue?vue&type=script&lang=js"
export * from "./ForwardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b7a7c",
  null
  
)

export default component.exports